import PropTypes from 'prop-types';
import * as React from 'react';

import FilterNodeItemLabel from './FilterNodeItemLabel';
import styles from './FilterNodeTypeBoolItem.less';
import {DynamicFilter, FILTER_TYPE_BOOL} from 'src/js/lib/filtering';
import {FilterNode as FilterNodeModel} from 'src/js/model/filters_config';

class FilterNodeTypeBoolItem extends React.PureComponent {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleClick(event) {
    if (event) {
      event.stopPropagation();
    }
    this.changeOrRemoveFilter();
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      this.changeOrRemoveFilter();
    }
    return true;
  }

  getFilter() {
    const {node, parentName} = this.props;
    const BoolFilter = DynamicFilter.getFilterClass(FILTER_TYPE_BOOL);
    return new BoolFilter({
      type: FILTER_TYPE_BOOL,
      property: parentName,
      value: node.getName(),
    });
  }

  changeOrRemoveFilter() {
    const {changeFilter, isFilterSelected, removeFilter} = this.props;
    const filter = this.getFilter();

    if (!isFilterSelected(filter)) {
      changeFilter(filter);
    } else {
      removeFilter(filter);
    }
  }

  render() {
    const {node, isOpened} = this.props;
    return (
      <span className={styles.dlFilterNodeTypeBoolItem}>
        <button
          type={'button'}
          className={styles.dlFilterNodeTypeBoolItemInput}
          onClick={this.handleClick}
          onKeyDown={this.handleKeyDown}
          tabIndex={isOpened ? 0 : -1}
        >
          <FilterNodeItemLabel label={node.getLabel()} />
        </button>
      </span>
    );
  }
}

FilterNodeTypeBoolItem.displayName = 'FilterNodeTypeBoolItem';

FilterNodeTypeBoolItem.propTypes = {
  node: PropTypes.instanceOf(FilterNodeModel).isRequired,
  changeFilter: PropTypes.func.isRequired,
  isOpened: PropTypes.bool,
  isFilterSelected: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
};

FilterNodeTypeBoolItem.defaultProps = {
  isOpened: false,
};

export default FilterNodeTypeBoolItem;
